import moment from "moment-timezone"
import { __constants } from './constants';

const tz = __constants.timezone || "local"

export const checkAvailability = (formate) => {
    const availFileTypes = ["image/png", "image/jpg", "image/jpeg", "image/svg"];
    if (!availFileTypes.includes(formate)) {
        return false;
    }
    return true;
}

export function makeRequestFormRequest(formRef) {
    const formData = new FormData()
    for (let i = 0; i < formRef.current.length; i++) {
        if (formRef.current[i].id)
            formData.append(formRef.current[i].id, formRef.current[i].value)
    }
    return formData;
}

export function makeRawRequest(formRef) {
    const request = {}
    for (let i = 0; i < formRef.current.length; i++) {
        if (formRef.current[i].id)
            request.formRef.current[i].id = formRef.current[i].value
    }
    return request;
}

export const requestValidator = (request) => {
    const formdata = new FormData();
    let result = { isValid: true, formdata }
    Object.entries(request).some((list) => {
        if (!list[1]) {
            result = { isValid: false, formdata: null }
            return true
        } else {
            formdata.append(list[0], list[1])
        }
        return false
    })
    return result
}

export const apiResponse = ({ error, data, message, status }) => {
    return {
        error: error ? error.length > 0 ? error[0] : "" : "",
        data: data || {},
        message: message || "Data successfully retrived",
        status: status || 200
    }
}

export const createQuery = (object) => {
    let query = ""
    Object.entries(object).forEach(item => {
        query = query + item[0] + "=" + item[1] + "&"
    })
    return query
}



export const formatWithTZ = (utcTime, formatStr = "HH:mm") => {
console.log("process.env.TIME_ZONE",process.env.TIME_ZONE);
console.log("REACT_APP_SERVER_URL",process.env.REACT_APP_SERVER_URL);
  console.log("tz",tz);
  if (!utcTime) return "-"
  return tz === "local"
    ? moment(utcTime).local().format(formatStr)
    : moment(utcTime).tz(tz).format(formatStr)
}

export const exportToCSV = (data, filename = 'export.csv') => {
  if (!data || !data.length) {
    return;
  }
  const separator = ',';
  const keys = Object.keys(data[0]);
  const csvContent =
    keys.join(separator) +
    '\n' +
    data.map(row => {
      return keys.map(k => {
        let cell = row[k] === null || row[k] === undefined ? '' : row[k];
        cell = cell instanceof Date
          ? cell.toLocaleString()
          : cell.toString().replace(/"/g, '""');
        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator);
    }).join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};